import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { UserCheck, FileSignature } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { ENTITY_DEFS } from "@/lib/entities";
import { useAuth } from "@/context/AuthContext";
import { EntityManager } from "@/components/EntityManager";
import { DocumentsPanel } from "@/components/DocumentsPanel";
import { BatchReportButton } from "@/components/BatchReportButton";
import { PageHeader } from "@/components/Ui";
import { Button } from "@/components/ui/button";

const SUBTITLES = {
  trusts: "Elenco dei Trust visibili al tuo profilo. Clicca su un Trust per aprire la scheda completa.",
  subjects: "Anagrafiche di persone fisiche e società. Ogni modifica è registrata con valore precedente e successivo.",
  prospects: "Potenziali clienti in fase di consulenza, convertibili in anagrafica.",
  deadlines: "Scadenzario fiscale, legale e amministrativo di tutti i Trust.",
  fiscal: "Dichiarazioni, imposte e adempimenti fiscali dei Trust.",
  chart_of_accounts: "Piano dei conti di riferimento per la contabilità dei Trust.",
};

export function EntityPage({ entity }) {
  const nav = useNavigate();
  const { can, hasRole } = useAuth();
  const contractBtn = (r) => hasRole("admin", "gestore_utenti", "collaboratore") && (
    <Button variant="ghost" size="sm" data-testid={`prospect-contract-${r.id}`} title="Contratto" onClick={() => nav(`/prospects/${r.id}/contract`)}>
      <FileSignature className="h-4 w-4 mr-1" />Contratto
    </Button>
  );
  const prospectAction = (r, reload) => <>{contractBtn(r)}{convertBtn(r, reload)}</>;
  const convertBtn = (r, reload) =>
    can("subjects", "c") && r.status !== "anagrafica_trust" ? (
      <Button variant="ghost" size="sm" data-testid={`prospect-convert-${r.id}`} title="Converti in anagrafica"
        onClick={async () => { try { await api.post(`/prospects/${r.id}/convert`); toast.success("Anagrafica creata"); reload(); } catch (e) { toast.error(errMsg(e)); } }}>
        <UserCheck className="h-4 w-4 mr-1" />Converti
      </Button>
    ) : null;

  return (
    <div>
      <PageHeader title={ENTITY_DEFS[entity].title} subtitle={SUBTITLES[entity]}>
        {entity === "trusts" && <BatchReportButton />}
      </PageHeader>
      <EntityManager entity={entity} showTrust onRowClick={entity === "trusts" ? (r) => nav(`/trusts/${r.id}`) : undefined}
        rowActions={entity === "prospects" ? prospectAction : undefined} />
    </div>
  );
}

export function DocumentsPage() {
  return (
    <div>
      <PageHeader title="Archivio Documenti" subtitle="Documenti con versionamento, impronta SHA-256 e cestino per il ripristino del singolo documento (TM-ISMS-07 §7.2)." />
      <DocumentsPanel />
    </div>
  );
}
